// Types
import type { TStoredRange, TQueryRange } from '~/misc/listings/types';

const normalizeRange = (range?: TStoredRange): TQueryRange => ({
  from: range?.from ?? undefined,
  to: range?.to ?? undefined,
});

export { normalizeRange };
